import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import * as fragments from '../fragments'

const DOC = gql`
  ${fragments.evaluation.DOC}
  query QuiverEvaluate(
    $tenantId: ID!
    $zoneId: ID!
    $resourceIds: [ID!]!
    $variables: [VariableValueInput!]
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        quiver {
          evaluate(resourceIds: $resourceIds, variables: $variables) {
            ...FragmentQuiverEvaluation
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.select<
  graphql.schema.QuiverEvaluateQuery,
  ents.core.quiver.Evaluation | undefined,
  'tenant'
>(
  'tenant',
  graphql.transformers.OUT.select(
    'zone',
    graphql.transformers.OUT.select(
      'quiver',
      graphql.transformers.OUT.select(
        'evaluate',
        fragments.evaluation.TRANSFORMER,
      ),
    ),
  ),
)

export const execute = graphql.createExecutor<
  graphql.schema.QuiverEvaluateQuery,
  ents.core.quiver.Evaluation | undefined,
  graphql.schema.QuiverEvaluateQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
